import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { SyllabusFormValues } from "src/models/Syllabus.model";

type Props = {
  formikProps: FormikProps<SyllabusFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const SyllabusForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          <div className="text-xl font-medium">
            {formType === "ADD" ? "Add Syllabus" : "Update Syllabus"}{" "}
          </div>
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="syllabusName"
            required
            value={values.syllabusName}
            onChange={(e) => {
              setFieldValue("syllabusName", e.target.value);
            }}
            label="Syllabus Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="order"
            required
            value={values.order}
            onChange={(e) => {
              setFieldValue("order", e.target.value);
            }}
            label="Order"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default SyllabusForm;
